import React from 'react'
import style from './style.module.scss'
import { TweenMax } from 'gsap'
import { connect } from 'react-redux'
import { toggleContact } from '../../state/actions/index'
import { NavItem } from '../'
import instagram from '../../images/instagram.png'
import facebook from '../../images/facebook.png'
import twitter from '../../images/twitter.png'
import Logo from '../../images/bimbo_logo.png';

const SocialIcon = (props) => {
    let self = null;

    const onMouseEnter = () => {
        TweenMax.to(self, 0.2, {
            scale: 1.1
        })
    }

    const onMouseLeave = () => {
        TweenMax.to(self, 0.2, {
            scale: 1.0
        })
    }

    const { imgSrc, link, alt } = props
    return (
        <a ref={ref => self = ref} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} href={link} target="_blank">
            <span>
                <img className={style.socialMedia} src={imgSrc} alt={alt} />
            </span>
        </a>
    )
}

const Footer = (props) => {

    const handleContactClick = (e) => {
        props.dispatch(toggleContact(true, 'bimbo'))
    }

    return (
        <div className={style.footerWrapper}>
            <div className={style.contentWrapper}>
                <div className={style.topContent}>
                    <div className={style.logo}>
                        <img src={Logo} />
                    </div>
                </div>
                <div className={style.coloredSpacer}>
                </div>
                <div className={style.siteMapWrapper}>
                    <div className={style.siteMapLeft}>
                        <span className={style.contactUs} onClick={handleContactClick}>Contact Us</span>
                        <span className={style.divider}>|</span>
                        <NavItem link="/">Privacy Policy</NavItem>
                    </div>
                    <div className={style.socialMediaSection}>
                        <SocialIcon imgSrc={facebook} link="https://www.facebook.com/Holsumpr/" alt="FACEBOOK" />
                        <SocialIcon imgSrc={instagram} link="https://www.instagram.com/holsumpuertorico/" alt="INSTAGRAM" />
                        <SocialIcon imgSrc={twitter} link="https://twitter.com/hashtag/holsumpr" alt="TWITTER" />
                    </div>
                    <div className={style.siteMapRight}>
                        <NavItem link="/">&copy; 2020 Bimbo</NavItem>
                        {/* <span className={style.divider}>|</span>
                        <NavItem link="/">Powered By Sapien Solutions</NavItem> */}
                    </div>
                </div>
            </div>
        </div>
    )

}


// export default Footer
export default connect()(Footer)

